const url = require('url');
const HOST = `http://${process.env.REACT_APP_BUILD_ENV}/` || '';

export default function getEndpointUrl(pathname) {
  return url.resolve(HOST, pathname);
}
